import { Component, Input, OnInit } from '@angular/core';
import { AddressComponent } from '../../../../shared/components/address/address.component';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzSwitchModule } from 'ng-zorro-antd/switch';
import { LookupValueItem } from '../../../../interfaces/lookup.interface';
import { NzAriaLabelDirective } from '../../../../shared/directives/nz-aria-label.directive';

@Component({
  selector: 'ppl-enrollment-address',
  standalone: true,
  imports: [  NzFormModule,
    NzInputModule,
    NzSelectModule,
    NzIconModule,
    FormsModule,
    ReactiveFormsModule,
    NzSwitchModule,
    CommonModule,
    NzAriaLabelDirective],
  templateUrl: './enrollment-address.component.html',
  styleUrl: './enrollment-address.component.css'
})
export class EnrollmentAddressComponent extends AddressComponent implements OnInit{
  @Input() formReadonly = false;
  states: LookupValueItem[] = [];

  override ngOnInit(): void {
    this.states = this.lookupService.getLookupValue('STATE');

  }

}
